module.exports = __webpack_public_path__ + "static/media/caramida-aparenta-klinker-Corum.c0b7e109.jpg";